import React from 'react';

export default function Download({
  width = 17,
  height = 16,
  color = '#616874',
  strokeWidth = '1.33333',
  className = '',
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 17 16'
      fill='none'
      className={className}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.1665 7.99935L8.49984 11.3327M8.49984 11.3327L11.8332 7.99935M8.49984 11.3327L8.49984 2.66602'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.5 13.334H12.5'
        stroke={color}
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
